<template>
    <div id="magic-zoom">
        <div itemscope itemtype="http://schema.org/Thing" :class="{'video-active': video == true}">
            <div class="ItemImgWrap justify-content-center" :class="{'more-images': magiczoom.images.all.length > 1 || findVideo!=='' }">
                <button class="btn btn-massband" @click="showMassband" v-if="proofMassband">
                    <img src="https://cdn02.plentymarkets.com/5rtbqcd0flq3/frontend/Webseite/SingleItem/Massband.png" :alt="$translate('Snaply5::Template.singleMassband')" :title="$translate('Snaply5::Template.singleMassband')" class="img-fluid">
                </button>
                <template v-if="magiczoom.images.all.length > 1 || findVideo!==''">
                    <div class="magic-more-images d-none d-lg-block" v-if="anzahlBilderAndStuff >= 4">
                        <div @click="slidePrev" class="fa-rotate-270 flipiconZoom mt-4" v-if="anzahlBilderAndStuff > 4">
                            <i class="snaply-chevron blue"></i>
                        </div>
                        <hooper class="d-none d-lg-block" :vertical="true" :infiniteScroll="false" :itemsToShow="4" :trimWhiteSpace="true" ref="carousel">
                            <slide v-if="findVideo!==''">
                              <a class="border videoplay-icon mz-thumb" @click="playVideo()">
                                <i class="fa fa-play-circle-o"></i>
                              </a>
                            </slide>
                            <slide v-for="(imagePreview, index) in magiczoom.images.all">
                                <a @click="videoFalse()" :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="border">
                                    <img
                                        :data-src="imagePreview.url"
                                        :src="imagePreview.urlPreview"
                                        :alt="magiczoom.texts.name1 + '-' + index"
                                        :title="magiczoom.texts.name1 + '-' + index">
                                </a>
                            </slide>
                        </hooper>
                        <div @click="slideNext" class="fa-rotate-90 mt-4" v-if="anzahlBilderAndStuff > 4">
                            <i class="snaply-chevron blue"></i>
                        </div>
                    </div>
                    <div class="magic-more-images d-none d-lg-block" v-else>
                        <a class="border videoplay-icon mb-2 border mz-thumb" @click="playVideo()" v-if="findVideo !== ''">
                          <i class="fa fa-play-circle-o"></i>
                        </a>
                        <template v-for="(imagePreview, index) in magiczoom.images.all">
                            <a @click="videoFalse()" :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="mb-2 border">
                                <img
                                    :data-src="imagePreview.url"
                                    :src="imagePreview.urlPreview"
                                    :alt="magiczoom.texts.name1 + '-' + index"
                                    :title="magiczoom.texts.name1 + '-' + index">
                            </a>
                        </template>
                    </div>
                </template>
                <!-- TODO: Magiczoom multiligual -->

                  <a href="#" :class="{'my-d-block' : video == true}">
                    <video width="100%" controls autoplay v-if="video == true" >
                      <source :src="findVideo" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <a :class="{'my-d-none' : video == true}" :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
                     :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Snaply5::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Snaply5::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Snaply5::Template.singleZoomHint')"
                     :data-options="'lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:'+$translate('Snaply5::Template.singleZoomHint3')+'; textExpandHint:'+ $translate('Snaply5::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'">
                    <img  class="img-fluid" :src="magiczoom.images | itemImages('urlMiddle') | itemImage" itemprop="image" :alt="magiczoom.texts.name1" :title="magiczoom.texts.name1">
                  </a>
            </div>
            <div class="zoom-navigation-dots d-lg-none" :class="{'d-none': video == true }">
            </div>
            <template v-if="findVideo">
              <div class="text-center d-lg-none my-3" v-if="video">
                <div class="btn btn-primary" @click="videoFalse()">
                  <i class="fa fa-picture-o ml-3"></i> {{ $translate('Snaply5::Template.singleShowGallery') }}
                </div>
              </div>
              <div v-else class="d-lg-none text-center my-3">
                <div class="btn btn-primary" @click="playVideo()">
                  <i class="fa fa-play-circle-o ml-3"></i> {{ $translate('Snaply5::Template.singlePlayVideo') }}
                </div>
              </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { Hooper, Slide  } from 'hooper';
    export default
    {
        components: { Hooper, Slide },
        props:
        {
            template:
            {
                type: String,
                default: "#vue-magic-zoom"
            },
            videourl:
            {
                type: String,
                default:null
            }
        },
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        data: function()
        {
            return {
                onloadVarId: this.currentVariation().variation.id,
                dotsCount: 0,
                massBand: false,
                video:false
            }
        },
        methods:
        {

            videoFalse: function()
            {
              this.video = false;
            },
            playVideo: function()
            {
                this.video = true;
            },
            showMassband: function()
            {
                if(this.massBand == true)
                {
                    $('#ItemImgZoom .raster').remove();
                    this.massBand = false
                }
                else
                {
                  $('#ItemImgZoom figure').prepend('<img src="https://cdn02.plentymarkets.com/5rtbqcd0flq3/frontend/Webseite/SingleItem/raster-neu.png" class="img-fluid raster" alt="Raster" title="Raster">');
                  this.massBand = true
                }
            },
            currentVariation: function()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
            getDots: function()
            {
               this.dotsCount =   this.currentVariation().images.all.length
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            slidePrev() {
                this.$refs.carousel.slidePrev();
            }
        },
        computed:
        {
            proofMassband: function()
            {
              let item = this.currentVariation();
              let _self = this;
              if(item.hasOwnProperty('tags'))
              {
                for(let i = 0; i < item.tags.length; i++ )
                {
                  if(item.tags[i].id === 45)
                  {
                    return true
                  }
                }
              }
              return false;
            },
            findVideo:function()
            {
              if(this.videourl !== "" && this.videourl !== null)
              {
                return this.videourl;
              }
              else
              {
                let _self     = this;
                let variation = this.currentVariation();
                if(variation.hasOwnProperty('variationProperties'))
                {
                  for(let i = 0; i < variation.variationProperties.length; i++)
                  {
                    for(let i2 = 0; i2 < variation.variationProperties[i].properties.length; i2++)
                    {
                      if(variation.variationProperties[i].properties[i2].id == 37)
                      {
                        return variation.variationProperties[i].properties[i2].values.value
                      }
                    }
                  }
                }
              }
              return '';
            },
            anzahlBilderAndStuff:function()
            {
              let images = this.currentVariation().images.all.length;
              if(this.findVideo!=='')
              {
                images = images+1;
              }
              return images
            },
            magiczoom: function()
            {
                this.getDots();
                return this.currentVariation();
            },
            massband: function()
            {
                let _self = this;
                return _self.massBand;
            }
        }
    }
</script>

